import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
} from '@mui/material';

interface LivingStatusFilterProps {
  filterValue: string | null;
  updateFilters: (value: string | null) => void;
  disabled?: boolean;
}

const LivingStatusFilter: React.FC<LivingStatusFilterProps> = ({
  filterValue,
  updateFilters,
  disabled = false,
}) => {
  const handleChange = (event: SelectChangeEvent<string>) => {
    const value = event.target.value;
    // Convert 'all' to empty string for backend, keep others as-is
    if (value === 'all') {
      updateFilters('');
    } else {
      updateFilters(value);
    }
  };

  // Convert filterValue to display value
  const getDisplayValue = (value: string | null): string => {
    if (value === null || value === '') return 'all';
    return value;
  };

  return (
    <FormControl fullWidth={true} variant="outlined" size="small">
      <InputLabel id="living-status">Living Status</InputLabel>
      <Select
        labelId="living-status-label"
        id="living-status-select"
        disabled={disabled}
        fullWidth={true}
        value={getDisplayValue(filterValue)}
        label="Living Status"
        onChange={handleChange}
      >
        <MenuItem key={'all'} value={'all'}>
          {'All'}
        </MenuItem>
        <MenuItem key={'living'} value={'true'}>
          {'Living'}
        </MenuItem>
        <MenuItem key={'deceased'} value={'false'}>
          {'Deceased'}
        </MenuItem>
      </Select>
    </FormControl>
  );
};

export default LivingStatusFilter;
